"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BC_CARD_AUTH_MAX_INPUTS = exports.BC_CARD_AUTH_CONTAINER = exports.BC_CARD_INPUT = exports.BC_CARD_INPUT_ERROR = exports.BC_CARD_BUTTON_PRIMARY = exports.BC_CARD_AUTHENTICATION = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.BC_CARD_AUTHENTICATION = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-card-auth");
exports.BC_CARD_BUTTON_PRIMARY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-button-primary");
exports.BC_CARD_INPUT_ERROR = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input-error");
exports.BC_CARD_INPUT = 'input';
exports.BC_CARD_AUTH_CONTAINER = "".concat(exports.BC_CARD_AUTHENTICATION, "-container");
exports.BC_CARD_AUTH_MAX_INPUTS = 4;
